import { useMemo } from "react";

export const usePosition = (position: string, S: { [key: string]: string }) => {
    const positionClass = useMemo(() => {
        switch (position) {
            case "POSITION_IMAGE_LEFT":
                return S.positionImageLeft;
            case "POSITION_IMAGE_BOTTOM":
                return S.positionImageBottom;
            default:
                return S.positionImageRight;
        }
    }, [position, S]);

    return {
        positionClass,
    };
};
